import React from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Grid2 from "@mui/material/Unstable_Grid2";
import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  InputLabel,
  Radio,
  RadioGroup,
  Select,
  TextField,
  inputClasses,
  inputLabelClasses,
} from "@mui/material";
import Home from "../home/Home";
import { Col, Form, Row } from "react-bootstrap";
import { useState } from "react";
import BillingService from "../../Services/billing/BillingService";
import { useEffect } from "react";
import { getDate, getPointId, getUserId } from "../Utils/Common";
import CustomServices from "../../Services/CustomServices";
import Snacbar from "../Snacbar";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useNavigate } from "react-router";
import { ToggleButton } from "@mui/material";

const CssTextField = styled(TextField)(`
  .${inputClasses.root} {
    height:35px;
  }
  .${inputLabelClasses.root} {
    font-family: Times New Roman;
    font-weight:bold;
    &.${inputLabelClasses.focused} {
      color: primary;
    }
  }
`);
const Csscontrol = styled(FormControl)({
  "& .MuiOutlinedInput-root": {
    "& fieldset": {},
  },
});
const Item = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  padding: theme.spacing(0.5),
  textAlign: "center",
  color: theme.palette.text.secondary,
  backgroundColor: "white",
  height: 520,
  border: "1px solid black",
}));
const Item1 = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  padding: theme.spacing(0.5),
  color: theme.palette.text.secondary,
  backgroundColor: "white",
  height: 520,
  border: "1px solid black",
}));
const ItemPpr = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  padding: theme.spacing(0.5),
  textAlign: "center",
  color: theme.palette.text.secondary,
  backgroundColor: "white",
  border: "1px solid black",
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    color: theme.palette.common.black,
    backgroundColor: "rgb(61, 195, 177)",
    padding: theme.spacing(0.5),
    fontFamily: "Times New Roman",
    fontWeight: "bold",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 15,
    fontFamily: "Times New Roman",
    textAlign: "center",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: "white",
  },
}));

function CustomActivity() {
  const getCurrentTime = () => {
    const current = new Date();
    // By default US English uses 12hr time with AM/PM
    const time = current.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });
    return time;
  };

  const [open, setOpen] = useState(false);
  const [severity, setSeverity] = useState("");
  const [message, setMessage] = useState("");

  const [values, setValues] = useState({
    consimentNo: "",
    filterBycus: "",
    customActivityId: "",
    operationDatetime: getDate() + "T" + getCurrentTime(),
    operationStatus: "",
    remarks: "",
  });
  const [CustomSaveDsa, setCustomSaveDsa] = useState(false);
  const [CustomUpdateDsa, setCustomUpdateDsa] = useState(true);
  const [CustomDeleteDsa, setCustomDeleteDsa] = useState(true);
  const [CustomSave, setCustomSave] = useState(false);
  const [CustomUpdate, setCustomUpdate] = useState(false);
  const [CustomDelete, setCustomDelete] = useState(false);
  const [remarksHidden, setRemarksHidden] = useState(true);
  const [selected, setSelected] = useState([]);
  const [filterType, setFilterType] = useState("jobNo");

  const [error, setError] = useState({
    operationDatetime: false,
    operationStatus: false,
  });

  const [ConsignmentJobEntryAssign, setConsignmentJobEntryAssign] = useState({
    txt_asJobNo: "",
    txt_asMawbNo: "",
    txt_asJobRefNo: "",
    txt_asImporterName: "",
    txt_asImporterCode: "",
    txt_asImporterState: "",
    ta_asimporterAddress: "",
    txt_asTransitType: "",
    txt_asAirlinesName: "",
    txt_asOriginCountry: "",
    txt_asOriginPort: "",
    txt_asClearancePort: "",
    txt_asArrivalDate: "",
    txt_asHawbNo: "",
    lbl_asMawbNo: "MAWB.No",
    lbl_asAirlinesName: "AirlinesName",
    lbl_asHawbNo: "HAWB.No",
  });

  const [ImporterDetails, setImporterDetails] = useState([]);
  const [CustomActivity, setCustomActivity] = useState([]);
  const [OperationStatus, setOperationStatus] = useState([]);
  const [label, setLabel] = useState("Job No");

  const [ImporterBasedConsignment, setImporterBasedConsignment] = useState([]);

  const CusAct_filterBycusHandleChange = (e) => {
    setValues({ ...values, filterBycus: e.target.value });
    var iecCode = "";
    if (e.target.value === "") {
      iecCode = "-1";
    } else {
      iecCode = e.target.value;
    }
    CustomServices.getImporterBasedConsignment(iecCode).then((res) => {
      setImporterBasedConsignment(res.data);
    });
  };

  const CusAct_operationDatetimeHandleChange = (e) => {
    setValues({ ...values, operationDatetime: e.target.value });
  };
  const CusAct_operationStatusHandleChange = (e) => {
    setValues({ ...values, operationStatus: e.target.value });
    if (
      e.target.value === "Remarks" ||
      e.target.value === "RMS" ||
      e.target.value === "Group"
    ) {
      setRemarksHidden(false);
    } else {
      setRemarksHidden(true);
    }
  };
  const CusAct_remarksHandleChange = (e) => {
    setValues({ ...values, remarks: e.target.value });
  };

  //getDataas
  const getDrpdata = async () => {
    BillingService.getImporterDetails().then((res) => {
      setImporterDetails(res.data);
    });
    CustomServices.getOperationStatus().then((res) => {
      setOperationStatus(res.data);
    });
  };

  const getData = async () => {
    CustomServices.getImporterBasedConsignment("-1").then((res) => {
      setImporterBasedConsignment(res.data);
    });
  };

  const getConsignmentJobEntryAssign = (val) => {
    setConsignmentJobEntryAssign({
      ...ConsignmentJobEntryAssign,
      txt_asJobNo: "",
      txt_asMawbNo: "",
      txt_asJobRefNo: "",
      txt_asImporterName: "",
      txt_asImporterCode: "",
      txt_asImporterState: "",
      ta_asimporterAddress: "",
      txt_asTransitType: "",
      txt_asAirlinesName: "",
      txt_asOriginCountry: "",
      txt_asOriginPort: "",
      txt_asClearancePort: "",
      txt_asArrivalDate: "",
      txt_asHawbNo: "",
      lbl_asMawbNo: "Mawb.No",
      lbl_asAirlinesName: "AirlinesName",
      lbl_asHawbNo: "Hawb.No",
    });
    CustomServices.getConsignmentJobEntryAssign(val)
      .then((res) => {
        const data = res.data;
        const lastResult = data.map((item) => item);

        if (JSON.stringify(lastResult) === [] || !lastResult[0]) {
          setConsignmentJobEntryAssign({
            ...ConsignmentJobEntryAssign,
            txt_asJobNo: "",
            txt_asMawbNo: "",
            txt_asJobRefNo: "",
            txt_asImporterName: "",
            txt_asImporterCode: "",
            txt_asImporterState: "",
            ta_asimporterAddress: "",
            txt_asTransitType: "",
            txt_asAirlinesName: "",
            txt_asOriginCountry: "",
            txt_asOriginPort: "",
            txt_asClearancePort: "",
            txt_asArrivalDate: "",
            txt_asHawbNo: "",
            lbl_asMawbNo: "Mawb.No",
            lbl_asAirlinesName: "AirlinesName",
            lbl_asHawbNo: "Hawb.No",
          });
        } else {
          var MawbNo,
            AirlinesName,
            HawbNo = "";
          if (lastResult[0].transitTypeName === "AIR") {
            MawbNo = "MAWB.No";
            AirlinesName = "AirlinesName";
            HawbNo = "HAWB.No";
          } else if (lastResult[0].transitTypeName === "SEA") {
            MawbNo = "MBL.No";
            AirlinesName = "ShipmentCompany";
            HawbNo = "HBL.No";
          }
          setConsignmentJobEntryAssign({
            ...ConsignmentJobEntryAssign,
            txt_asJobNo: lastResult[0].consignmentId,
            txt_asMawbNo: lastResult[0].wayBillNumber,
            txt_asJobRefNo: lastResult[0].edi_refno,
            txt_asImporterName: lastResult[0].importer_name,
            txt_asImporterCode: lastResult[0].importer_iec_no,
            txt_asImporterState: lastResult[0].deliveryStateName,
            ta_asimporterAddress: lastResult[0].senderAddress,
            txt_asTransitType: lastResult[0].transitTypeName,
            txt_asAirlinesName: lastResult[0].shipmentCompanyName,
            txt_asOriginCountry: lastResult[0].countryName,
            txt_asOriginPort: lastResult[0].origin_portName,
            txt_asClearancePort: lastResult[0].destinationName,
            txt_asArrivalDate: lastResult[0].expectedArrivalDateTime,
            txt_asHawbNo: lastResult[0].hawb_no,
            lbl_asMawbNo: MawbNo,
            lbl_asAirlinesName: AirlinesName,
            lbl_asHawbNo: HawbNo,
          });
        }
      })
      .catch((error) => {
        setConsignmentJobEntryAssign({
          ...ConsignmentJobEntryAssign,
          txt_asJobNo: "",
          txt_asMawbNo: "",
          txt_asJobRefNo: "",
          txt_asImporterName: "",
          txt_asImporterCode: "",
          txt_asImporterState: "",
          ta_asimporterAddress: "",
          txt_asTransitType: "",
          txt_asAirlinesName: "",
          txt_asOriginCountry: "",
          txt_asOriginPort: "",
          txt_asClearancePort: "",
          txt_asArrivalDate: "",
          txt_asHawbNo: "",
          lbl_asMawbNo: "Mawb.No",
          lbl_asAirlinesName: "AirlinesName",
          lbl_asHawbNo: "Hawb.No",
        });
      });
  };

  const getCustomActivity = (val) => {
    CustomServices.getCustomActivity(val).then((res) => {
      setCustomActivity(res.data);
    });
  };

  useEffect(() => {
    getDrpdata();
    getData();
  }, []);

  //tableClicks
  const EditImpBasedCustomDetails = (item) => {
    const selectedIndex = selected.indexOf(item.consignmentNumber);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = (selected, item.consignmentNumber);
    }
    setSelected(newSelected);

    setCustomSaveDsa(false);
    setCustomUpdateDsa(true);
    setCustomDeleteDsa(true);
    setCustomSave(false);
    setCustomUpdate(false);
    setCustomDelete(false);
    setValues({
      ...values,
      consimentNo: item.consignmentId,
      operationDatetime: getDate() + "T" + getCurrentTime(),
      operationStatus: "",
      remarks: "",
      customActivityId: "",
    });
    getConsignmentJobEntryAssign(item.consignmentId);
    getCustomActivity(item.consignmentId);
    setError({ ...error, operationDatetime: false, operationStatus: false });
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  const EditCustomActivityDetails = (item) => {
    setCustomSaveDsa(true);
    setCustomUpdateDsa(false);
    setCustomDeleteDsa(false);
    setCustomSave(false);
    setCustomUpdate(false);
    setCustomDelete(false);
    if (
      item.operationStatus === "Remarks" ||
      item.operationStatus === "RMS" ||
      item.operationStatus === "Group"
    ) {
      setRemarksHidden(false);
    } else {
      setRemarksHidden(true);
    }
    setValues({
      ...values,
      operationDatetime: item.operationDate,
      operationStatus: item.operationStatus,
      remarks: item.remarks,
      customActivityId: item.customActivityId,
    });
    setError({ ...error, operationDatetime: false, operationStatus: false });
  };

  //ClickEvents

  const validate = () => {
    if (values.operationDatetime !== "") {
      if (values.operationStatus !== "") {
        return true;
      } else {
        setError({ ...error, operationStatus: true });
        document.getElementById("operationSts").focus();
        setOpen(true);
        setSeverity("warning");
        setMessage("Please Select Operation Status ..!!");
      }
    } else {
      setError({ ...error, operationDatetime: true });
      document.getElementById("operationDateTime").focus();
      setOpen(true);
      setSeverity("warning");
      setMessage("Please Select Operation Date&Time ..!!");
    }
    return false;
  };

  const insertCustomActivity = () => {
    if (validate() === true) {
      if (values.consimentNo !== "") {
        setCustomSaveDsa(true);
        setCustomSave(true);
        let details = {
          consignmentId: values.consimentNo,
          pointId: getPointId(),
          operationStatus: values.operationStatus,
          operationDate: values.operationDatetime,
          createdBy: getUserId(),
          remarks: values.remarks,
        };
        CustomServices.insertCustomActivity(details)
          .then((res) => {
            const message = res.data.message;
            if (message.toString() === "SUCCESS") {
              setOpen(true);
              setSeverity("success");
              setMessage(message);
            } else {
              setOpen(true);
              setSeverity("error");
              setMessage("Insertion Failed " + message);
            }
            reset();
            getCustomActivity(values.consimentNo);
          })
          .catch((error) => {
            setOpen(true);
            setSeverity("success");
            setMessage("Insertion Failed " + error.message);
            reset();
          });
      } else {
        setOpen(true);
        setSeverity("warning");
        setMessage("Please Select Job No From Job Table ..!!");
      }
    }
  };
  const updateCustomActivity = () => {
    if (values.customActivityId !== "") {
      if (validate() === true) {
        if (values.consimentNo !== "") {
          setCustomUpdateDsa(true);
          setCustomUpdate(true);
          let details = {
            customActivityId: values.customActivityId,
            consignmentId: values.consimentNo,
            pointId: getPointId(),
            operationStatus: values.operationStatus,
            operationDate: values.operationDatetime,
            createdBy: getUserId(),
            remarks: values.remarks,
          };
          CustomServices.updateCustomActivity(details)
            .then((res) => {
              const message = res.data.message;
              if (message.toString() === "SUCCESS") {
                setOpen(true);
                setSeverity("success");
                setMessage(message);
              } else {
                setOpen(true);
                setSeverity("error");
                setMessage("Updation Failed " + message);
              }
              reset();
              getCustomActivity(values.consimentNo);
            })
            .catch((error) => {
              setOpen(true);
              setSeverity("success");
              setMessage("Updation Failed " + error.message);
              reset();
            });
        } else {
          setOpen(true);
          setSeverity("warning");
          setMessage("Please Select Job No From Job Table ..!!");
        }
      }
    } else {
      setOpen(true);
      setSeverity("warning");
      setMessage("Kindly Select Job No Details from below DataGrid table ..!");
    }
  };
  const deleteCustomActivity = () => {
    if (values.customActivityId !== "") {
      if (values.consimentNo !== "") {
        setCustomDeleteDsa(true);
        setCustomDelete(true);
        CustomServices.deleteCustomActivity(values.customActivityId)
          .then((res) => {
            const message = res.data.message;
            if (message.toString() === "SUCCESS") {
              setOpen(true);
              setSeverity("success");
              setMessage(message);
            } else {
              setOpen(true);
              setSeverity("error");
              setMessage("Failed To Delete" + message);
            }
            reset();
            getCustomActivity(values.consimentNo);
          })
          .catch((error) => {
            setOpen(true);
            setSeverity("success");
            setMessage("Failed To Delete" + error.message);
            reset();
          });
      } else {
        setOpen(true);
        setSeverity("warning");
        setMessage("Please Select Job No From Job Table ..!!");
      }
    } else {
      setOpen(true);
      setSeverity("warning");
      setMessage("Kindly Select Job No Details from below DataGrid table ..!");
    }
  };
  const reset = () => {
    setCustomSaveDsa(false);
    setCustomUpdateDsa(true);
    setCustomDeleteDsa(true);
    setCustomSave(false);
    setCustomUpdate(false);
    setCustomDelete(false);
    setValues({
      ...values,
      operationDatetime: getDate() + "T" + getCurrentTime(),
      operationStatus: "",
      remarks: "",
      customActivityId: "",
    });
    setError({ ...error, operationDatetime: false, operationStatus: false });
  };
  const refresh = () => {
    setCustomActivity([]);
    setCustomSaveDsa(false);
    setCustomUpdateDsa(true);
    setCustomDeleteDsa(true);
    setCustomSave(false);
    setCustomUpdate(false);
    setCustomDelete(false);
    setValues({
      ...values,
      operationDatetime: getDate() + "T" + getCurrentTime(),
      operationStatus: "",
      remarks: "",
      customActivityId: "",
      consimentNo: "",
    });
    setError({ ...error, operationDatetime: false, operationStatus: false });
    setConsignmentJobEntryAssign({
      ...ConsignmentJobEntryAssign,
      txt_asJobNo: "",
      txt_asMawbNo: "",
      txt_asJobRefNo: "",
      txt_asImporterName: "",
      txt_asImporterCode: "",
      txt_asImporterState: "",
      ta_asimporterAddress: "",
      txt_asTransitType: "",
      txt_asAirlinesName: "",
      txt_asOriginCountry: "",
      txt_asOriginPort: "",
      txt_asClearancePort: "",
      txt_asArrivalDate: "",
      txt_asHawbNo: "",
      lbl_asMawbNo: "Mawb.No",
      lbl_asAirlinesName: "AirlinesName",
      lbl_asHawbNo: "Hawb.No",
    });
  };

  //handleClose/open
  const handleClose = () => {
    setOpen(false);
  };

  const navigate = useNavigate();
  const BackBotton = () => {
    navigate("/checklistVerify");
  };
  const ForwordBotton = () => {
    navigate("/besbupdation");
  };
  const CusAct_filterTypeHandleChange = (e) => {
    const value = e.target.value;
    setFilterType(value);

    if (value === "beNo") {
      // Hide dropdown data and clear table
      setValues({ ...values, filterBycus: "", consimentNo: "" });
      setImporterBasedConsignment([]);
      setLabel("BE No");
    } else {
      // Restore data for job mode
      getData();
      setLabel("Job No");
    }
  };

  return (
    <div>
      <Home />{" "}
      <Snacbar
        open={open}
        message={message}
        severity={severity}
        onClose={handleClose}
      />
      <div style={{ paddingLeft: "80px" }}>
        <Row>
          <Col xs={1}>
            <ToggleButton
              onClick={BackBotton}
              className="headerstyleStrt"
              size="small"
            >
              <ArrowBackIosIcon
                fontSize="small"
                style={{
                  fontSize: "16px",
                  marginLeft: "5px",
                  color: "red",
                  fontWeight: "bold",
                }}
              />{" "}
            </ToggleButton>
          </Col>
          <Col xs={10}></Col>
          <Col xs={1} style={{ textAlign: "end" }}>
            {" "}
            <ToggleButton
              onClick={ForwordBotton}
              className="headerstyleEND"
              size="small"
            >
              <ArrowForwardIosIcon
                fontSize="small"
                style={{ fontSize: "16px", color: "red", fontWeight: "bold" }}
              />{" "}
            </ToggleButton>
          </Col>
        </Row>
        <Grid2 container>
          <Box style={{ width: "30%" }}>
            <Item1>
              <Row>
                <Col xs={1} style={{ marginTop: "4%", marginBottom: "1%" }}>
                  {/* <ToggleButton onClick={BackBotton} className='headerstyleStrt' size="small" > 
                        <ArrowBackIosIcon fontSize='small' style={{ fontSize: '16px',marginLeft:'5px' }}/> </ToggleButton> */}
                </Col>
                <Col xs={11}>
                  {/* Radio Buttons */}
                  <FormControl component="fieldset" style={{ marginTop: "4%" }}>
                    <RadioGroup
                      row
                      value={filterType}
                      onChange={CusAct_filterTypeHandleChange}
                      name="filterType"
                    >
                      <FormControlLabel
                        value="jobNo"
                        control={<Radio size="small" />}
                        label="Job No"
                      />
                      <FormControlLabel
                        value="beNo"
                        control={<Radio size="small" />}
                        label="BE No"
                      />
                    </RadioGroup>
                  </FormControl>

                  {/* Filter Dropdown (visible only when Job No) */}
                  {filterType === "jobNo" && (
                    <Csscontrol
                      fullWidth
                      size="small"
                      style={{
                        width: "80%",
                        backgroundColor: "white",
                        marginTop: "2%",
                        marginBottom: "1%",
                      }}
                    >
                      <InputLabel id="demo-select-small">
                        Filter By Customer
                      </InputLabel>
                      <Select
                        native
                        label="Filter By Customer"
                        value={values.filterBycus}
                        onChange={CusAct_filterBycusHandleChange}
                      >
                        <option value={""}></option>
                        {ImporterDetails.map((item) => (
                          <option
                            key={item.importer_iec_no}
                            value={item.importer_iec_no}
                          >
                            {item.importer_name}
                          </option>
                        ))}
                      </Select>
                    </Csscontrol>
                  )}
                </Col>
              </Row>
              <TableContainer
                sx={{ maxHeight: 430 }}
                className="scrollbarPrime"
              >
                <Table
                  stickyHeader
                  className="table table-bordered-dark border-dark"
                >
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell align="center">Sl No</StyledTableCell>
                      <StyledTableCell align="center">Job No</StyledTableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {ImporterBasedConsignment.map((item) => {
                      const isItemSelected = isSelected(item.consignmentId);
                      return (
                        <StyledTableRow
                          hover
                          selected={isItemSelected}
                          tabIndex={-1}
                          key={item.consignmentId}
                          onClick={() => EditImpBasedCustomDetails(item)}
                        >
                          <StyledTableCell align="center">
                            {item.serialNumber}
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            {item.consignmentNumber}
                          </StyledTableCell>
                        </StyledTableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </Item1>
          </Box>
          <Box style={{ width: "40%" }}>
            <Item>
              <div
                style={{
                  fontFamily: "Times New Roman",
                  color: "red",
                  fontWeight: "bold",
                  fontSize: "25px",
                  marginTop: "2%",
                  marginBottom: "5%",
                }}
              >
                <center>CUSTOM ACTIVITY ENTRY</center>
              </div>
              <Row>
                <Col></Col>
                <Col
                  style={{
                    fontFamily: "Times New Roman",
                    color: "blue",
                    marginTop: "2.5%",
                    fontSize: "22px",
                  }}
                >
                  <label>{label}</label>
                </Col>
                <Col xs={3}>
                  <Form.Control
                    size="sm"
                    style={{
                      fontFamily: "Times New Roman",
                      textAlign: "center",
                      color: "darkred",
                      fontWeight: "bold",
                      height: "35px",
                      fontSize: "28px",
                      width: "200px",
                    }}
                    disabled={filterType === "jobNo"}
                    value={values.consimentNo}
                    onChange={(e) =>
                      setValues({ ...values, consimentNo: e.target.value })
                    }
                  />
                </Col>
                <Col></Col>
              </Row>
              <Col>
                <CssTextField
                  size="small"
                  style={{
                    fontFamily: "Times New Roman",
                    marginTop: "4%",
                    fontWeight: "bold",
                  }}
                  label="Operation Date&Time"
                  type={"datetime-local"}
                  InputLabelProps={{ shrink: true }}
                  value={values.operationDatetime}
                  onChange={CusAct_operationDatetimeHandleChange}
                  required
                  error={error.operationDatetime}
                  id="operationDateTime"
                />
              </Col>
              <Col>
                <Csscontrol
                  fullWidth
                  size="small"
                  style={{
                    fontFamily: "Times New Roman",
                    marginTop: "3%",
                    width: "243px",
                    backgroundColor: "white",
                    fontWeight: "bold",
                  }}
                >
                  <InputLabel
                    id="demo-select-small"
                    style={{ fontFamily: "Times New Roman" }}
                  >
                    Operation Status
                  </InputLabel>
                  <Select
                    native
                    label="Operation Status"
                    value={values.operationStatus}
                    onChange={CusAct_operationStatusHandleChange}
                    id="operationSts"
                    required
                    error={error.operationStatus}
                  >
                    <option value=""></option>
                    {OperationStatus.map((item) => (
                      <option
                        key={item.operationType}
                        value={item.operationStatus}
                      >
                        {item.operationStatus}
                      </option>
                    ))}
                  </Select>
                </Csscontrol>
              </Col>
              <Col>
                <CssTextField
                  size="small"
                  style={{
                    fontFamily: "Times New Roman",
                    marginTop: "3%",
                    fontWeight: "bold",
                    width: "243px",
                    backgroundColor: "white",
                  }}
                  label="Remarks"
                  variant="outlined"
                  value={values.remarks}
                  onChange={CusAct_remarksHandleChange}
                  hidden={remarksHidden}
                />
              </Col>

              <div className="mt-5 mb-1 form-inline">
                <Button
                  size="small"
                  variant="contained"
                  className="mt-1"
                  color="success"
                  style={{ fontFamily: "Times New Roman" }}
                  disabled={CustomSaveDsa}
                  onClick={insertCustomActivity}
                >
                  {CustomSave ? "Processing.." : "Save"}
                </Button>{" "}
                <Button
                  size="small"
                  variant="contained"
                  className="mt-1"
                  color="secondary"
                  style={{ fontFamily: "Times New Roman" }}
                  disabled={CustomUpdateDsa}
                  onClick={updateCustomActivity}
                >
                  {CustomUpdate ? "Processing" : "Update"}
                </Button>{" "}
                <Button
                  size="small"
                  variant="contained"
                  className="mt-1"
                  color="error"
                  style={{ fontFamily: "Times New Roman" }}
                  disabled={CustomDeleteDsa}
                  onClick={deleteCustomActivity}
                >
                  {CustomDelete ? "Processing..." : "Delete"}
                </Button>{" "}
                <Button
                  size="small"
                  variant="contained"
                  className="mt-1"
                  color="warning"
                  style={{ fontFamily: "Times New Roman" }}
                  onClick={refresh}
                >
                  REFRESH
                </Button>{" "}
              </div>
            </Item>
          </Box>
          <Box style={{ width: "30%" }}>
            <Item className="p-1">
              <Row className="mt-2">
                <Col xs={4}></Col>
                <Col xs={3}></Col>
                <Col xs={1}></Col>
                <Col xs={4}>
                  {/* <ToggleButton onClick={ForwordBotton} size="small" className='headerstyleEND'>  
                            <ArrowForwardIosIcon fontSize="small" style={{ fontSize: '16px'}} /> </ToggleButton>      */}
                </Col>
              </Row>
              <Row className="mt-2">
                <Col
                  xs={4}
                  style={{
                    fontFamily: "Times New Roman",
                    textAlign: "left",
                    fontWeight: "bold",
                    color: "black",
                  }}
                >
                  <label>Job.No</label>
                </Col>
                <Col xs={1}>
                  <label className="summury" style={{ fontSize: "15px" }}>
                    :
                  </label>
                </Col>
                <Col xs={7} style={{ textAlign: "left" }} className="summury">
                  {ConsignmentJobEntryAssign.txt_asJobNo}
                </Col>
              </Row>
              <Row className="mt-2">
                <Col
                  xs={4}
                  style={{
                    fontFamily: "Times New Roman",
                    textAlign: "left",
                    fontWeight: "bold",
                    color: "black",
                  }}
                >
                  <label>{ConsignmentJobEntryAssign.lbl_asMawbNo}</label>
                </Col>
                <Col xs={1}>
                  <label className="summury" style={{ fontSize: "15px" }}>
                    :
                  </label>
                </Col>
                <Col xs={7} style={{ textAlign: "left" }} className="summury">
                  {ConsignmentJobEntryAssign.txt_asMawbNo}
                </Col>
              </Row>
              <Row className="mt-2">
                <Col
                  xs={4}
                  style={{
                    fontFamily: "Times New Roman",
                    textAlign: "left",
                    fontWeight: "bold",
                    color: "black",
                  }}
                >
                  <label>Job_Ref.No</label>
                </Col>
                <Col xs={1}>
                  <label className="summury" style={{ fontSize: "15px" }}>
                    :
                  </label>
                </Col>
                <Col xs={7} style={{ textAlign: "left" }} className="summury">
                  {ConsignmentJobEntryAssign.txt_asJobRefNo}
                </Col>
              </Row>
              <Row className="mt-2">
                <Col
                  xs={4}
                  style={{
                    fontFamily: "Times New Roman",
                    textAlign: "left",
                    fontWeight: "bold",
                    color: "black",
                  }}
                >
                  <label>Customer Name</label>
                </Col>
                <Col xs={1}>
                  <label className="summury" style={{ fontSize: "15px" }}>
                    :
                  </label>
                </Col>
                <Col xs={7} style={{ textAlign: "left" }} className="summury">
                  {ConsignmentJobEntryAssign.txt_asImporterName}
                </Col>
              </Row>
              <Row className="mt-2">
                <Col
                  xs={4}
                  style={{
                    fontFamily: "Times New Roman",
                    textAlign: "left",
                    fontWeight: "bold",
                    color: "black",
                  }}
                >
                  <label>Customer Code</label>
                </Col>
                <Col xs={1}>
                  <label className="summury" style={{ fontSize: "15px" }}>
                    :
                  </label>
                </Col>
                <Col xs={7} style={{ textAlign: "left" }} className="summury">
                  {ConsignmentJobEntryAssign.txt_asImporterCode}
                </Col>
              </Row>
              <Row className="mt-2">
                <Col
                  xs={4}
                  style={{
                    fontFamily: "Times New Roman",
                    textAlign: "left",
                    fontWeight: "bold",
                    color: "black",
                  }}
                >
                  <label>Customer State</label>
                </Col>
                <Col xs={1}>
                  <label className="summury" style={{ fontSize: "15px" }}>
                    :
                  </label>
                </Col>
                <Col xs={7} style={{ textAlign: "left" }} className="summury">
                  {ConsignmentJobEntryAssign.txt_asImporterState}
                </Col>
              </Row>
              <Row className="mt-2">
                <Col
                  xs={4}
                  style={{
                    fontFamily: "Times New Roman",
                    textAlign: "left",
                    fontWeight: "bold",
                    color: "black",
                  }}
                >
                  <label>Customer Address</label>
                </Col>
                <Col xs={1}>
                  <label className="summury" style={{ fontSize: "15px" }}>
                    :
                  </label>
                </Col>
                <Col xs={7} style={{ textAlign: "left" }} className="summury">
                  {ConsignmentJobEntryAssign.ta_asimporterAddress}
                </Col>
              </Row>

              <Row className="mt-2">
                <Col
                  xs={4}
                  style={{
                    fontFamily: "Times New Roman",
                    textAlign: "left",
                    fontWeight: "bold",
                    color: "black",
                  }}
                >
                  <label>Transit Type</label>
                </Col>
                <Col xs={1}>
                  <label className="summury" style={{ fontSize: "15px" }}>
                    :
                  </label>
                </Col>
                <Col xs={7} style={{ textAlign: "left" }} className="summury">
                  {ConsignmentJobEntryAssign.txt_asTransitType}
                </Col>
              </Row>
              <Row className="mt-2">
                <Col
                  xs={4}
                  style={{
                    fontFamily: "Times New Roman",
                    textAlign: "left",
                    fontWeight: "bold",
                    color: "black",
                  }}
                >
                  <label>{ConsignmentJobEntryAssign.lbl_asAirlinesName}</label>
                </Col>
                <Col xs={1}>
                  <label className="summury" style={{ fontSize: "15px" }}>
                    :
                  </label>
                </Col>
                <Col xs={7} style={{ textAlign: "left" }} className="summury">
                  {ConsignmentJobEntryAssign.txt_asAirlinesName}
                </Col>
              </Row>
              <Row className="mt-2">
                <Col
                  xs={4}
                  style={{
                    fontFamily: "Times New Roman",
                    textAlign: "left",
                    fontWeight: "bold",
                    color: "black",
                  }}
                >
                  <label>Orgin Country</label>
                </Col>
                <Col xs={1}>
                  <label className="summury" style={{ fontSize: "15px" }}>
                    :
                  </label>
                </Col>
                <Col xs={7} style={{ textAlign: "left" }} className="summury">
                  {ConsignmentJobEntryAssign.txt_asOriginCountry}
                </Col>
              </Row>
              <Row className="mt-2">
                <Col
                  xs={4}
                  style={{
                    fontFamily: "Times New Roman",
                    textAlign: "left",
                    fontWeight: "bold",
                    color: "black",
                  }}
                >
                  <label>Orgin Port</label>
                </Col>
                <Col xs={1}>
                  <label className="summury" style={{ fontSize: "15px" }}>
                    :
                  </label>
                </Col>
                <Col xs={7} style={{ textAlign: "left" }} className="summury">
                  {ConsignmentJobEntryAssign.txt_asOriginPort}
                </Col>
              </Row>
              <Row className="mt-2">
                <Col
                  xs={4}
                  style={{
                    fontFamily: "Times New Roman",
                    textAlign: "left",
                    fontWeight: "bold",
                    color: "black",
                  }}
                >
                  <label>Clearance Port</label>
                </Col>
                <Col xs={1}>
                  <label className="summury" style={{ fontSize: "15px" }}>
                    :
                  </label>
                </Col>
                <Col xs={7} style={{ textAlign: "left" }} className="summury">
                  {ConsignmentJobEntryAssign.txt_asClearancePort}
                </Col>
              </Row>
              <Row className="mt-2">
                <Col
                  xs={4}
                  style={{
                    fontFamily: "Times New Roman",
                    textAlign: "left",
                    fontWeight: "bold",
                    color: "black",
                  }}
                >
                  <label>Arrival Date</label>
                </Col>
                <Col xs={1}>
                  <label className="summury" style={{ fontSize: "15px" }}>
                    :
                  </label>
                </Col>
                <Col xs={7} style={{ textAlign: "left" }} className="summury">
                  {ConsignmentJobEntryAssign.txt_asArrivalDate}
                </Col>
              </Row>
              <Row className="mt-2">
                <Col
                  xs={4}
                  style={{
                    fontFamily: "Times New Roman",
                    textAlign: "left",
                    fontWeight: "bold",
                    color: "black",
                    marginBottom: "1%",
                  }}
                >
                  <label>{ConsignmentJobEntryAssign.lbl_asHawbNo}</label>
                </Col>
                <Col xs={1}>
                  <label className="summury" style={{ fontSize: "15px" }}>
                    :
                  </label>
                </Col>
                <Col xs={7} style={{ textAlign: "left" }} className="summury">
                  {ConsignmentJobEntryAssign.txt_asHawbNo}
                </Col>
              </Row>
            </Item>
          </Box>
        </Grid2>
        <ItemPpr>
          <TableContainer sx={{ maxHeight: 140 }}>
            <Table
              stickyHeader
              className="table table-bordered-dark border-dark"
            >
              <TableHead>
                <StyledTableRow>
                  <StyledTableCell align="center">Sl</StyledTableCell>
                  <StyledTableCell align="center">Job No</StyledTableCell>
                  <StyledTableCell align="center">
                    Operation Location
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    Operation Status
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    Operation Date Time
                  </StyledTableCell>
                  <StyledTableCell align="center">Remarks</StyledTableCell>
                  <StyledTableCell align="center">User Name</StyledTableCell>
                </StyledTableRow>
              </TableHead>
              <TableBody>
                {CustomActivity.map((item) => (
                  <StyledTableRow
                    hover
                    key={item.customActivityId}
                    onClick={() => EditCustomActivityDetails(item)}
                  >
                    <StyledTableCell align="center">
                      {item.serialNumber}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {item.consignmentId}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {item.userLocation}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {item.operationStatus}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {item.operationDate}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {item.remarks}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {item.userName}
                    </StyledTableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </ItemPpr>
      </div>
    </div>
  );
}

export default CustomActivity;
